import React, { useState }  from "react"
import { ResponsiveBar }    from '@nivo/bar'
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome'
import { Toggler }          from '../../shared/Toggler'

const CELL_HEIGHT = 450
const TAB_HEIGHT  = 350
const BAR_THICKNESS = 40
const BAR_GAP_Y     = 10
const BAR_WIDTH     = 40
const BAR_GAP_X     = 16

const noValue = data => data ? data.map(v => v.value).reduce((a, b) => a + b, 0) === 0 : true

const EmptyCard = () => {
  return(
    <div
      className="dashboard__card--empty"
      style={{ height: `${TAB_HEIGHT}px` }}
    >
      {I18n.t('dashboard.no_data')}
    </div>
  )
}

const Ratio = ({ ratio , range = 0, horizontal, collection, setItem }) => {
  const data = ratio.data.filter(data => data.value >= range)

  const horizontalProps = {
    margin:      { left: 140, right: 20 },
    enableGridY: false,
    axisLeft:    { tickSize: 0, tickPadding: 20},
  }

  const verticalProps = {
    margin:      { bottom: 170, left: 0, right: 20, top: 20 },
    enableGridY: false,
    axisBottom:  { tickSize: 0, tickPadding: 20, tickRotation: -90},
    axisLeft:    { tickSize: 0, tickPadding: 20}
  }

  const barProps = horizontal ? horizontalProps : verticalProps
  
  const onClick = selected => {
    const item = collection.find(item => item.id == selected.data.id)
    if (setItem) setItem(item)
  }

  const innerVPad = (barProps.margin.top || 0) + (barProps.margin.bottom || 0)
  const innerHPad = (barProps.margin.left || 0) + (barProps.margin.right || 0)

  const rows = data.length
  const chartHeight = horizontal
    ? rows * BAR_THICKNESS + Math.max(0, rows - 1) * BAR_GAP_Y + innerVPad
    : CELL_HEIGHT

  const chartMinWidth = horizontal
    ? 'auto'
    : rows * BAR_WIDTH + Math.max(0, rows - 1) * BAR_GAP_X + innerHPad

  return (
    <div>
      <h3>{ratio.title}</h3>

      { noValue(data)
        ? <EmptyCard />
        : <div style={{ 
            height: horizontal ? Math.min(chartHeight, CELL_HEIGHT) : CELL_HEIGHT,
            maxHeight: CELL_HEIGHT,
            minWidth: chartMinWidth
          }}>
            <ResponsiveBar
              data           = { data }
              layout         = { horizontal ? 'horizontal' : 'vertical' }
              padding        = { .2 }
              onClick        = { onClick }
              indexBy        = "name"
              colors         = { bar => bar.data.color }
              labelTextColor = { bar => bar.data.data.text }
              animate
              {...barProps}
            />
          </div>
      }
    </div>
  )
}

export const ChartTab = ({ ratios, range, categories, setCategory, statuses, setStatus, title }) => {
  const [horizontal, setHorizontal] = useState(true)
  const toggleHorizontal = () => {
    setHorizontal(!horizontal)
  }

  return (
    <Toggler title={title} opened={true}>
      <div className="dashboard__card">
        <div className="btn btn-primary btn-sm small mr-2" onClick={toggleHorizontal}>
          {horizontal ?
            <>
              <FontAwesomeIcon icon='chart-bar' /> {I18n.t('dashboard.vertical')}
            </>
             :
            <>
              <FontAwesomeIcon icon="bars" /> {I18n.t('dashboard.horizontal')}
            </>
          }
        </div>

        <div className={`dashboard__demands_container_${horizontal ? 'horizontal' : 'vertical'}`}>
          <Ratio
            ratio       = { ratios.category_ratio }
            range       = { range }
            horizontal  = { horizontal }
            collection  = { categories }
            setItem     = { setCategory }
          />

          <Ratio
            ratio       = { ratios.status_ratio }
            range       = { range }
            collection  = { statuses }
            setItem     = { setStatus }
            horizontal  = { horizontal }
          />
        </div>
      </div>
    </Toggler>
  )
}

export default ChartTab
